import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './BackToTop.css';

/**
 * Floating "Back to top" control (ported to document.body).
 * @param {number} threshold - Show after scrolling past this many px (0 = always visible)
 */
const BackToTop = ({ threshold = 200 }) => {
  const [visible, setVisible] = useState(threshold <= 0);

  useEffect(() => {
    if (threshold <= 0) {
      setVisible(true);
      return undefined;
    }

    const update = () => {
      const y =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      setVisible(y > threshold);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    return () => window.removeEventListener('scroll', update);
  }, [threshold]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    document.documentElement.scrollTo({ top: 0, behavior: 'smooth' });
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible || typeof document === 'undefined') return null;

  return createPortal(
    <button
      type="button"
      className="app-back-to-top"
      aria-label="Back to top"
      title="Back to top"
      onClick={scrollToTop}
    >
      <i className="fas fa-arrow-up" aria-hidden="true" />
    </button>,
    document.body
  );
};

export default BackToTop;
